var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.483,
    height: 202.605,
    viewBox: "0 0 162.483 202.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(-145.797 -2756.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(-257.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M566.053,2932.573l-16.663-19.481.429-.151c6.679-2.345,11.759-7.854,11.759-14.922a16.7,16.7,0,0,0-16.676-16.676H524.451v6.929h20.53a9.775,9.775,0,0,1,9.669,9.746c0,5.375-4.966,8.934-10.341,8.934l-9.315-.006,21.934,25.626Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M444.759,2881.367l-9.094.011-21.687,25.533,21.714,25.644h9.076l-21.594-25.54Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M410.234,2881.378H403.57v23.771l6.664-7.86Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M410.234,2916.545l-6.664-7.86v24.046h6.664Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M484.576,2932.553h.011c.37,0,.769-.014,1.219-.04a20.91,20.91,0,0,0,19.719-19.727c.023-.422.023-1.912,0-2.316v-29.1h-6.8v30.5a14.155,14.155,0,0,1-28.3,0v-30.5h-6.8v29.1c-.023.4-.023,1.894,0,2.316a20.91,20.91,0,0,0,19.719,19.727c.45.026.849.039,1.219.04h.012Z",
    fill: "#a7b5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M432.666,2950.488h2.757a2.369,2.369,0,0,1,2.652,2.408,2.408,2.408,0,0,1-1.7,2.35l1.907,3.385h-1.093l-1.8-3.292h-1.78v3.292h-.942Zm2.757,4.014a1.521,1.521,0,0,0,1.675-1.606,1.55,1.55,0,0,0-1.733-1.57h-1.757v3.176Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M445.786,2950.488h4.641v.861h-3.7v2.711h3.187v.849h-3.187v2.873h3.827v.849h-4.769Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M457.474,2956.212h.942a1.789,1.789,0,0,0,2,1.7c1.07,0,1.838-.524,1.838-1.373,0-2.547-4.5-.767-4.5-4.024a2.323,2.323,0,0,1,2.606-2.176,2.428,2.428,0,0,1,2.675,2.362h-.965c0-.931-.617-1.5-1.722-1.5-1.151,0-1.652.64-1.652,1.315,0,2.221,4.514.674,4.514,3.966,0,1.28-1.047,2.3-2.827,2.3A2.689,2.689,0,0,1,457.474,2956.212Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M470.768,2950.488h4.641v.861h-3.7v2.711H474.9v.849H471.71v2.873h3.828v.849h-4.77Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M485.307,2950.488h1.1l3.129,8.143h-.989l-.732-1.931h-3.932l-.733,1.931h-.989Zm2.187,5.351-1.6-4.257h-.07l-1.606,4.257Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M496.751,2950.488h2.757a2.369,2.369,0,0,1,2.652,2.408,2.408,2.408,0,0,1-1.7,2.35l1.908,3.385h-1.094l-1.8-3.292h-1.779v3.292h-.943Zm2.757,4.014a1.521,1.521,0,0,0,1.675-1.606,1.55,1.55,0,0,0-1.733-1.57h-1.756v3.176Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M509.289,2954.56a4.108,4.108,0,0,1,4.188-4.223,3.893,3.893,0,0,1,3.827,2.757h-1.012a2.846,2.846,0,0,0-2.815-1.872,3.341,3.341,0,0,0,0,6.676,2.768,2.768,0,0,0,2.78-1.873H517.3a3.846,3.846,0,0,1-3.839,2.757A4.084,4.084,0,0,1,509.289,2954.56Z",
    fill: "#a7b5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M524.862,2950.488h.943v3.572h4.327v-3.572h.942v8.143h-.942v-3.71H525.8v3.71h-.943Z",
    fill: "#a7b5b7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(-257.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M481.771,2861.748c-.185-14.3-.259-36.84-.277-51.308l.138.24c-7.324-4.244-26.2-15.192-33.261-19.348l-11.043-6.525,11.179,6.291c7.047,3.981,26.13,14.927,33.4,19.1l.139.08v.16c-.044,14.516-.066,36.95-.276,51.308Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M437.328,2784.807c11.627,7.4,24.772,15.853,35.972,23.773,1.466,1.058,2.952,2.092,4.33,3.271a4.074,4.074,0,0,1,.606.634,13.433,13.433,0,0,1,.643,3.155c1.625,14.73,2.256,31.257,2.887,46.114-1.03-13.206-2.088-33.095-3.606-46.02a15.714,15.714,0,0,0-.559-2.868,7.743,7.743,0,0,0-1.037-.952c-10.629-8.044-28.132-19.418-39.236-27.107Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M437.328,2784.807c6.436,4.631,12.763,9.409,19.032,14.264,3.142,2.419,6.23,4.908,9.294,7.43,3.036,2.644,6.293,4.972,8.811,8.17,1.642,3.724,2.027,7.75,2.815,11.691.659,3.914,1.267,7.834,1.779,11.767,1.043,7.86,1.972,15.735,2.7,23.63-1.023-7.006-2.332-16.653-3.41-23.529-.623-3.911-1.2-7.829-1.9-11.723-.77-3.771-1.24-7.833-2.777-11.357-2.387-3.021-5.657-5.452-8.556-8-3.029-2.547-6.126-5.017-9.2-7.521-5.382-4.367-13.112-10.44-18.591-14.822Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M437.328,2784.807c8.8,7.483,17.431,15.178,25.618,23.336a68.2,68.2,0,0,1,7.745,8.712,40.2,40.2,0,0,1,2.663,6.834c1.521,5.079,2.829,10.233,3.969,15.4,1.667,7.521,3.174,15.074,4.434,22.672-2.822-12.168-5.466-24.4-8.993-36.385-.352-1.23-.923-2.88-1.332-4.091a31.555,31.555,0,0,0-1.7-3.858,68.515,68.515,0,0,0-7.512-8.575c-7.809-7.918-16.806-16.33-24.9-24.049Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M437.328,2784.807c7.9,8.088,15.529,16.436,22.769,25.121,2.949,3.7,6.1,7.347,8.17,11.646,4.416,9.392,7.426,19.411,10.465,29.307,1.038,3.622,2.09,7.239,3.021,10.89-1.214-3.566-2.387-7.143-3.631-10.7-3.377-9.729-6.627-19.6-11.01-28.929-2.05-4.187-5.081-7.75-7.97-11.441-6.823-8.475-14.727-17.565-21.814-25.9Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M437.328,2784.807c9.077,11.8,17.875,23.774,25.81,36.4,7.413,12.938,13.161,26.722,18.61,40.571-5.784-11.8-13.32-28.637-19.885-39.8-7.849-12.592-16.442-24.725-24.535-37.171Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M437.328,2784.807c5.35,9.242,11.148,19.721,16.443,28.993,9.181,15.925,19.228,31.82,27.972,47.983-8.146-12.114-16.189-25.052-23.822-37.539-7.566-12.787-14.306-25.991-20.593-39.437Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M437.328,2784.807c5.392,13.834,10.751,27.909,18.244,40.733a328.715,328.715,0,0,0,19.306,27.381c2.241,2.989,4.566,5.912,6.861,8.867a221.537,221.537,0,0,1-27.762-35.282c-7.529-13.007-12.6-27.283-16.649-41.7Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M437.328,2784.807c2.978,14.831,6.813,29.761,14.462,42.9a123.756,123.756,0,0,0,13.7,18.051,200.255,200.255,0,0,0,16.244,16.037,121.1,121.1,0,0,1-29.345-29.378c-9.392-13.882-13.557-31.111-15.062-47.609Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M437.328,2784.807c.139,19.4,4.422,39.657,17.481,54.521A104.231,104.231,0,0,0,481.73,2861.8c-15.829-7.064-29.78-19.234-37.792-34.744-6.22-13-8.113-28.015-6.61-42.249Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M437.328,2784.807c-2.752,15.88-1.517,33.209,6.906,47.249,1.011,1.476,2.281,3.648,3.386,5.023l1.853,2.4c.523.719,1.4,1.607,1.986,2.291a68.869,68.869,0,0,0,7.648,7.375,74.306,74.306,0,0,0,22.619,12.662,62.473,62.473,0,0,1-42.464-34.116c-5.848-13.4-6.1-28.992-1.934-42.883Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M437.328,2784.807c-5.718,15.927-5.91,34.764,3.136,49.443a57.793,57.793,0,0,0,28.785,24.194,55.18,55.18,0,0,0,12.472,3.368,51.208,51.208,0,0,1-24.933-7.528,53.217,53.217,0,0,1-23.773-30.942,55.607,55.607,0,0,1,4.313-38.535Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M486.656,2861.807V2810.44l44.339-25.715",
    fill: "none",
    stroke: "#a6b2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.498,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M531.179,2785.007c-12.816,8.514-25.773,16.857-38.17,25.975a24.828,24.828,0,0,0-2.031,1.689l-.193.226-.1.271a113.783,113.783,0,0,0-1.333,11.78c-.971,12.278-1.685,24.578-2.361,36.876l-.673-.035c.8-14.357,1.533-28.721,2.853-43.043a48.991,48.991,0,0,1,.8-5.781,2.2,2.2,0,0,1,.77-1.088c.581-.531,1.2-1,1.817-1.48,5.76-4.314,11.754-8.3,17.708-12.336q10.228-6.876,20.542-13.618l.369.564Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M531.223,2785.029c-9.461,7.194-18.887,14.454-28,22.079-2.9,2.558-6.149,5-8.512,8.059-1.535,3.475-1.97,7.629-2.731,11.367-2,11.717-3.507,23.519-4.943,35.316l-.755-.087q1.375-11.823,3.015-23.61c.849-5.894,1.708-11.792,2.9-17.632a24.436,24.436,0,0,1,1.717-5.837,15.206,15.206,0,0,1,2.032-2.315c5.031-4.809,10.533-9.088,15.957-13.433q9.342-7.377,18.863-14.515l.457.608Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M531.263,2785.029c-9.236,8.413-18.53,16.809-27.16,25.848a50.618,50.618,0,0,0-5.469,6.551,29.635,29.635,0,0,0-2.134,5.223c-4.021,12.839-6.636,26.087-9.446,39.233l-.8-.155q1.083-5.681,2.261-11.338c1.61-7.543,3.278-15.069,5.3-22.518,1.063-3.7,2.038-7.606,3.861-11.02a51.135,51.135,0,0,1,5.642-6.716c6-6.274,12.378-12.165,18.773-18.026q4.287-3.879,8.633-7.69l.537.608Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M531.3,2785.008q-7.572,8.372-14.926,16.949c-2.434,2.869-4.859,5.744-7.214,8.672-2.89,3.689-5.861,7.309-7.908,11.5-4.339,9.362-7.48,19.273-10.753,29.045q-1.767,5.362-3.443,10.755l-.8-.235q1.563-5.439,3.228-10.842c2.255-7.2,4.591-14.376,7.285-21.432a77.951,77.951,0,0,1,4.667-10.4c6.256-9.518,14.029-17.8,21.554-26.285q3.817-4.174,7.7-8.288l.607.566Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M531.323,2784.964c-8.422,12.214-17.124,24.3-24.842,36.969-5.541,9.629-10.1,19.839-14.808,29.9q-2.352,5.052-4.644,10.133l-.747-.321q2.136-5.158,4.346-10.28c4.524-10.225,9.022-20.461,14.57-30.192,3.868-6.388,8.077-12.522,12.352-18.629q6.416-9.135,13.116-18.059l.657.478Z",
    fill: "#a6b2b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M531.333,2784.9c-6.492,13.092-13.623,26.638-20.929,39.28-7.579,12.463-15.556,25.527-23.423,37.825l-.65-.4c7.239-12.673,15.13-25.773,22.627-38.276,6.529-11.1,15.338-27.377,21.7-38.783l.676.353Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M531.318,2784.827c-4.278,14.385-9.606,28.481-16.991,41.6-7.77,12.886-17.251,24.57-27.418,35.6l-.507-.451c2.361-2.889,4.721-5.786,7.009-8.734,9.174-11.7,18.138-23.706,24.513-37.2q4.789-10.094,8.807-20.545c1.378-3.467,2.671-6.972,3.94-10.479l.647.2Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M531.273,2784.755a115.3,115.3,0,0,1-10.333,38.788c-7.622,15.618-20.28,28.277-34.116,38.488l-.336-.449a172.493,172.493,0,0,0,16.407-15.819,112.334,112.334,0,0,0,12.112-15.7,100.879,100.879,0,0,0,10.38-23.217,161.68,161.68,0,0,0,5.329-22.151l.557.06Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M531.2,2784.7c1.752,15.78-1.191,32.341-9.03,46.228a76.564,76.564,0,0,1-24.949,25.42,75.239,75.239,0,0,1-10.478,5.64l-.169-.371a89.8,89.8,0,0,0,9.91-6.347c20.667-15.028,31.265-33.319,33.856-58.77a88.4,88.4,0,0,0,.455-11.758l.405-.042Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M531.1,2784.692a61.408,61.408,0,0,1,.047,36.979,58.735,58.735,0,0,1-21.852,30.05,60.289,60.289,0,0,1-22.615,10.193l-.048-.215a66.346,66.346,0,0,0,11.27-4.869c22.552-11.9,35.468-34.435,34.449-59.882a65.448,65.448,0,0,0-1.462-12.19l.211-.066Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M530.995,2784.725c14.391,26.445,2.256,60.71-25.219,72.734a49.479,49.479,0,0,1-19.12,4.348,55.179,55.179,0,0,0,12.509-3.283c29.656-11.1,43.613-44.648,31.83-73.8Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M528.579,2780.534l-44.334,25.57L439.8,2780.54",
    fill: "none",
    stroke: "#a5b1b5",
    strokeMiterlimit: 10,
    strokeWidth: 1.498,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M528.732,2780.835c-13.752,6.892-27.414,14-41.491,20.21-.724.294-1.437.6-2.191.83a2.077,2.077,0,0,1-1.326.088,51.224,51.224,0,0,1-5.4-2.19c-13.052-5.984-25.857-12.484-38.683-18.933l.305-.6c13.751,6.847,27.425,13.9,41.489,20.087a24.809,24.809,0,0,0,2.473.92,1.051,1.051,0,0,0,.581.021,110.155,110.155,0,0,0,10.852-4.7c11.107-5.276,22.105-10.788,33.081-16.331l.306.6Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M528.729,2780.884c-10.927,4.675-21.883,9.28-33.023,13.431-1.862.684-3.73,1.352-5.62,1.97a25.554,25.554,0,0,1-5.9,1.437c-4.032-.51-7.7-2.149-11.5-3.438-3.721-1.372-7.411-2.816-11.09-4.284q-11.034-4.418-21.948-9.111l.3-.7c10.933,4.613,21.907,9.162,33.044,13.26,3.652,1.233,7.39,2.84,11.207,3.344,3.813-.444,7.555-2.091,11.2-3.311,11.134-4.1,22.1-8.669,33.028-13.3l.3.7Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M528.71,2780.919c-11.839,4.042-23.736,7.956-35.88,10.991a46.732,46.732,0,0,1-8.64,1.485,48.286,48.286,0,0,1-8.635-1.511c-8.418-2.068-16.687-4.67-24.941-7.3q-5.489-1.789-10.947-3.662l.261-.769c12.328,3.968,24.67,8.015,37.275,11.015a43.8,43.8,0,0,0,6.99,1.109,33.283,33.283,0,0,0,5.588-.793c5.627-1.18,11.161-2.8,16.679-4.412,7.36-2.2,14.691-4.524,21.988-6.924l.262.769Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M528.674,2780.938c-10.982,2.664-22.012,5.123-33.173,6.93a87.761,87.761,0,0,1-11.312,1.2,88.974,88.974,0,0,1-11.31-1.218c-7.445-1.19-14.819-2.723-22.179-4.338q-5.51-1.24-11-2.569l.19-.808q5.5,1.218,11.031,2.339c7.355,1.518,14.737,2.953,22.151,4.13a88.61,88.61,0,0,0,11.117,1.16,72.894,72.894,0,0,0,8.335-.735c8.352-1.2,16.667-2.842,24.93-4.546q5.523-1.131,11.027-2.353l.191.807Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M528.625,2780.939c-14.763,1.8-29.55,3.515-44.437,3.8-14.886-.3-29.672-2.013-44.436-3.8l.091-.808q5.537.528,11.086.986c14.75,1.195,29.536,2.847,44.34,1.724,7.4-.463,14.794-1.061,22.179-1.72q5.546-.467,11.085-.995l.092.808Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M528.566,2780.916c-14.4-.1-30.043-.5-44.378-.5-14.32,0-30,.407-44.378.506l-.026-.762a723.219,723.219,0,0,1,77.717-.572c3.7.181,7.4.339,11.091.566l-.026.763Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M528.508,2780.866c-14.65-2.43-29.446-4.672-44.319-4.779-11.144.051-22.258,1.442-33.28,3.039-3.689.518-7.369,1.126-11.041,1.746l-.141-.664c3.638-.887,7.3-1.61,10.974-2.325a198.9,198.9,0,0,1,33.487-3.66,197.152,197.152,0,0,1,33.489,3.644c3.671.717,7.336,1.443,10.973,2.336l-.142.663Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M528.467,2780.791c-14.172-5.119-29.17-8.867-44.275-9.031-11.306.082-22.584,2.38-33.455,5.506-3.651,1.033-7.264,2.232-10.829,3.531l-.222-.514a124.769,124.769,0,0,1,21.68-7.5,103.359,103.359,0,0,1,18.485-2.934,91.88,91.88,0,0,1,27.168,2.9,121.683,121.683,0,0,1,21.672,7.526l-.224.513Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M528.459,2780.7c-13.316-8-28.658-13.133-44.263-13.268-11.683.071-23.216,3.132-33.853,7.866a90.238,90.238,0,0,0-10.428,5.408l-.236-.332c19.256-14.129,45.3-19.54,68-11A78.221,78.221,0,0,1,528.7,2780.37l-.239.33Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M528.5,2780.609c-22.27-19.969-53.308-23.356-78.773-7.291a66.985,66.985,0,0,0-9.846,7.3l-.162-.15a60.776,60.776,0,0,1,20.105-14.452,59.314,59.314,0,0,1,54.345,2.792,57.366,57.366,0,0,1,14.495,11.655l-.164.149Z",
    fill: "#a5b1b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M528.579,2780.534c-16.171-20.905-45.193-27.848-68.916-16.06A59.25,59.25,0,0,0,439.8,2780.54a50.027,50.027,0,0,1,13.345-14.312c23.986-17.711,59.906-11.446,75.437,14.306Z",
    fill: "#a5b1b5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.126afee3a206c20da0f181a6fb9ec5dc.svg";
export { ForwardRef as ReactComponent };